export default async function getIPService(onSuccess?: (ip: string) => void, onError?: (error: string) => void) {
    try {
        const response = await fetch(`https://get.geojs.io/v1/ip.json`, {
            next: {
                revalidate: 3600,
            },
        });
        const data = await response.json();
        if (!data) {
            throw new Error(`GeoJS API failed with status: ${response.status}`);
        }
        onSuccess?.(data.ip);
        return data.ip;
    } catch (error) {
        onError?.(error as string);
    }
}
